import { useState } from "react";
import { Box } from "@mui/system";
import VerificationInput from "react-verification-input";

interface IProps {
  data: {
    google2fa_code: string;
    google2fa_qrcode: string;
  },
  code?: string;
  setCode: (code: string) => void;
}

export default function EnabledGoogleAuthenticator({ code, setCode }: IProps) {
  const [loading, setLoading] = useState(false);

  return (
    <Box sx={{
      flex: 1,
      maxWidth: 340,
      paddingTop: 1,
      margin: "0 auto",
      minHeight: 200,
      alignItems: "center",
    }}>
      <VerificationInput
        length={6}
        onChange={(value) => {
          if (loading) return;

          const code = value.replace(/[^0-9]/g, "");
          setCode(code);
        }}
        value={code}
        placeholder="."
        autoFocus
      />
    </Box>
  )
}
